export default "__VITE_ASSET__CZSC12UI__"